import React, {
  FC, useMemo, useState, useEffect,
} from 'react';
import _ from 'lodash';
import { DropdownItem, Badge } from 'reactstrap';
import Isvg from 'react-inlinesvg';
import classnames from 'classnames';

import quickFilterDates from 'app/utils/static/quickFilterDates';
import { unformatAmount, getTimeRange, parseAmount } from 'app/utils/parsers';

import PaymentBadge from 'app/components/general/PaymentBadge';

import { IMatchPayment } from 'app/ducks/paymentEvents/types';

import history from 'app/routes/history';
import IconModal from 'app/components/general/IconModal';
import Table from 'app/components/general/TableNew';
import ModalConfirm from 'app/components/general/ModalConfirm';
import Button from 'app/components/general/Button';
import ActionDots from 'app/components/general/ActionDots';
import PlusIcon from 'app/images/icons/plus.svg';
import DeleteIcon from 'app/images/icons/delete.svg';
import EditIcon from 'app/images/icons/edit.svg';
import StatusBadge from 'app/components/general/StatusBadge';
import BadgeWithTooltip from 'app/components/general/BadgeWithTooltip';

import moment from 'moment';

import { getGroupSummary } from 'app/ducks/groups/selectors';
import { IGroup } from 'app/ducks/groups/types';
import CreateTeam from 'app/components/teams/CreateTeam';
import { parsePaymentStatus, getPaymentEventForDashboard } from 'app/ducks/paymentEvents/selectors';
import ImportIcon from 'app/images/icons/upload.svg';
import PersonIcon from 'app/images/icons/person.svg';
import UniformIcon from 'app/images/icons/shirt.svg';

interface IProps {
  actions: any;
  competitions: any;
  paymentEventsById: IGroup[];
  paymentEventIds: string[];
  teamId?: string;
  headerTitle?: string;
  appReady?: boolean;
  isLoading?: boolean;
  manual?: boolean;
  saveFilters?: boolean;
  initialFilterConfig?: any;
  persistentFilterConfig?: any;
  pagination?: any;
  selectTeam: (value) => void;
}

const FixtureMatchesTable: FC<IProps> = (props: IProps = {
  manual: true,
  actions: undefined,
  paymentEventsById: undefined,
  paymentEventIds: undefined,
  initialFilterConfig: {},
  persistentFilterConfig: {},
  isLoading: false,
  pagination: undefined,
  selectTeam: undefined,
}) => {
  // const [createModalOpen, setCreateModalOpen] = useState(false);
  // const [editModalOpen, setEditModalOpen] = useState(false);
  // const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  // const [teamId, setTeamId] = useState(undefined);

  const filterOptions = [
    {
      label: 'Payment Status',
      accessor: 'subscriptionPaymentStatus',
      type: 'select',
      options: [
        { id: 'pending', name: 'Unpaid' },
        { id: 'paid', name: 'Teammo' },
        { id: 'paid-transferred', name: 'Transferred' },
        { id: 'paid-refunded', name: 'Refunded' },
        { id: 'walkover', name: 'Forfeit' },
        { id: 'cancelled', name: 'Cancelled' },
        { id: 'paid-cash', name: 'Cash' },
        { id: 'paid-eftpos', name: 'Eftpos' },
        { id: 'paid-prepaid', name: 'Pre-paid' },
        { id: 'transfer-required', name: 'Transfer Pending' },
        { id: 'transferred', name: 'Transferred' },
        { id: 'refunded', name: 'Refunded' },
      ],
    },
    {
      label: 'Match Status',
      accessor: 'paymentEventStatus',
      type: 'select',
      options: [
        { id: 'active', name: 'Active' },
        { id: 'cancelled', name: 'Cancelled' },
      ],
    },
    {
      label: 'Match Date',
      accessor: 'roundLocalDateAt',
      type: 'datetime',
    },
    {
      label: 'Team',
      accessor: 'groupName',
      type: 'text',
    },
    // {
    //   label: 'Reference',
    //   accessor: 'paymentReference',
    //   type: 'text',
    // },
    {
      label: 'Round',
      accessor: 'description',
      type: 'text',
    },
    {
      label: 'Amount',
      accessor: 'amount',
      type: 'currency',
    },
    {
      label: 'Competition',
      accessor: 'competitionId',
      type: 'select',
      options: props.competitions?.activeCompetitionsByIdInSelectFormat,
    },
    {
      label: 'Section',
      accessor: 'groupSectionName',
      type: 'text',
    },
  ];

  // const quickFilterOptions = [
  //   {
  //     label: 'Match Date',
  //     accessor: 'roundLocalDateAt',
  //     type: 'datetime',
  //   },
  //   {
  //     label: 'Team',
  //     accessor: 'groupName',
  //     type: 'text',
  //   },
  //   {
  //     label: 'Competition',
  //     accessor: 'competitionId',
  //     type: 'select',
  //     options: props.competitions?.activeCompetitionsByIdInSelectFormat,
  //   },
  // ];

  const fetchDataFromApi = ({
    sort, filter, pageNumber, pageSize,
  }): void => {
    if (
      props.appReady
      && !props.isLoading
      && (pageNumber !== props.pagination.page.number
        || (!_.isEmpty(sort) && sort !== props.pagination.sort)
        || filter !== props.pagination.filter)
    ) {
      // const groupName = _.find(sort, (f) => f.id === 'groupName');
      // if (groupName) {
      //   _.remove(sort, (f: any) => f.id === 'groupName');
      //   sort.push({ id: 'groups.name', desc: groupName.desc });
      // }
      // const groupSectionName = _.find(sort, (f) => f.id === 'groupSectionName');
      // if (groupSectionName) {
      //   _.remove(sort, (f: any) => f.id === 'groupSectionName');
      //   sort.push({ id: 'groups.sectionName', desc: groupSectionName.desc });
      // }
      // const groupSeasonName = _.find(sort, (f) => f.id === 'groupSeasonName');
      // if (groupSeasonName) {
      //   _.remove(sort, (f: any) => f.id === 'groupSeasonName');
      //   sort.push({ id: 'groups.seasonName', desc: groupSeasonName.desc });
      // }

      // const amount = _.find(filter, (f) => f.id === 'amount');
      // if (amount) {
      //   const cents = Math.trunc((unformatAmount(amount.value) * 100)).toString();
      //   _.remove(filter, (f: any) => f.id === 'amount');
      //   filter.push({ id: 'amount', value: cents });
      // }
      // const roundLocalDateAt = _.find(filter, (f) => f.id === 'roundLocalDateAt');
      // if (roundLocalDateAt) {
      //   const { sinceTimeParsed, untilTimeParsed } = getTimeRange(roundLocalDateAt.value[0], roundLocalDateAt.value[1]);
      //   _.remove(filter, (f: any) => f.id === 'roundLocalDateAt');
      //   filter.push({ id: 'roundLocalDateAt.since', value: sinceTimeParsed });
      //   filter.push({ id: 'roundLocalDateAt.until', value: untilTimeParsed });
      // }
      props.actions.getAllPaymentEvents({
        page: {
          size: pageSize,
          number: pageNumber,
        },
        sort,
        filter,
      });
    }
  };

  const handleClick = (id: string): void => {
    // props.selectPaymentEvent(id);
    // history.push(`/payments/segments/matches/detail/${id}`);
  };

  const data = useMemo(() => {
    if (_.isEmpty(props.paymentEventsById) || props.paymentEventIds === undefined) {
      return [];
    }
    const rows = _.reduce(
      props.paymentEventIds,
      (obj, id) => {
        if (!_.isEmpty(props.paymentEventsById[id])) {
          obj.push(getPaymentEventForDashboard(props.paymentEventsById[id]));
        }
        return obj;
      },
      [],
    );
    return rows;
  }, [props.paymentEventsById, props.paymentEventIds]);

  const microColumn = 'col col-3 col-sm-2 col-lg-1 col-xl-1';
  const smallColumn = 'col col-4 col-sm-3 col-lg-2 col-xl-2';
  const mediumColumn = 'col col-7 col-md-3 col-lg-3 col-xl-3';
  const largeColumn = 'col col-10 col-md-4 col-lg-4 col-xl-3';

  const renderTeamCell = (cellProps) => (
    <div className="d-flex align-items-center w-100">
      <div className="d-flex flex-wrap">
        <span className="d-inline-block">
          {cellProps.value.teamName}
        </span>
      </div>

      <div className="ml-auto">
        <div className="d-flex flex-wrap negative-margin-bottom-5 justify-content-end">
          {(cellProps.value.regularPlayers !== undefined && cellProps.value.regularPlayers > 0) && (
            <Badge className="margin-left-5 small margin-bottom-5" color="grey">
              <Isvg src={PersonIcon} className="misc-icon" />
              {cellProps.value.regularPlayers}
            </Badge>
          )}
          {(cellProps.value.fillInPlayers !== undefined && cellProps.value.fillInPlayers > 0) && (
            <Badge className="margin-left-5 small margin-bottom-5" color="yellow">
              <Isvg src={PersonIcon} className="misc-icon" />
              {cellProps.value.fillInPlayers}
            </Badge>
          )}
          {cellProps.value.hireUniforms !== undefined && (
            <Badge className="margin-left-5 small text-capitalize margin-bottom-5" color="blue">
              <Isvg src={UniformIcon} className="misc-icon" />
              {cellProps.value.hireUniforms}
            </Badge>
          )}
          <PaymentBadge
            className="event-card-badge margin-left-5 margin-bottom-5 no-margin-right"
            paymentText={cellProps.value.status}
          />
        </div>
      </div>
    </div>
  );
  const columns = useMemo(() => [
    {
      Header: 'Match Time',
      accessor: 'eventTimeSimple',
      className: microColumn,
      headerClassName: microColumn,
      disableSortBy: true,
    },
    {
      Header: 'Location',
      accessor: 'eventLocation',
      className: smallColumn,
      headerClassName: smallColumn,
      disableSortBy: true,
    },
    {
      Header: 'Home Team',
      className: largeColumn,
      headerClassName: largeColumn,
      disableSortBy: true,
      accessor: (row) => ({
        teamName: row.groupOneName,
        status: row.groupOnePaymentText,
        regularPlayers: row.groupOnePaymentData?.metadata?.lineItems?.regularPlayers?.quantity,
        fillInPlayers: row.groupOnePaymentData?.metadata?.lineItems?.fillInPlayers?.quantity,
        hireUniforms: row.groupOnePaymentData?.metadata?.lineItems?.hireUniforms?.quantity,
      }),
      Cell: (cellProps: {
        value: {
          teamName: string;
          status: string;
          regularPlayers: number;
          fillInPlayers: number;
          hireUniforms: string;
        };
      }) => renderTeamCell(cellProps),
    },
    {
      Header: 'Away Team',
      className: largeColumn,
      headerClassName: largeColumn,
      disableSortBy: true,
      accessor: (row) => ({
        teamName: row.groupTwoName,
        status: row.groupTwoPaymentText,
        regularPlayers: row.groupTwoPaymentData?.metadata?.lineItems?.regularPlayers?.quantity,
        fillInPlayers: row.groupTwoPaymentData?.metadata?.lineItems?.fillInPlayers?.quantity,
        hireUniforms: row.groupTwoPaymentData?.metadata?.lineItems?.hireUniforms?.quantity,
      }),
      Cell: (cellProps: {
        value: {
          teamName: string;
          status: string;
          regularPlayers: number;
          fillInPlayers: number;
          hireUniforms: string;
        };
      }) => renderTeamCell(cellProps),
    },
    {
      Header: 'Section',
      accessor: 'eventSection',
      className: mediumColumn,
      headerClassName: mediumColumn,
      disableSortBy: true,
    },
  ], []);

  const counterText = props.pagination.meta.totalCount === 1 ? '1 match' : `${props.pagination.meta.totalCount || 0} match`;

  return (
    <div>
      <Table
        data={data}
        columns={columns}
        isLoading={props.isLoading}
        // aggressiveLoader
        headerTitle={props.headerTitle}
        objectTitle="matches"
        filterTitle="Matches Data"
        counterText={counterText}
        handleClick={handleClick}
        // filterable
        saveFilters={props.saveFilters}
        manual={props.manual}
        fetchDataFromApi={fetchDataFromApi}
        filterOptions={filterOptions}
        // quickFilterOptions={quickFilterOptions}
        filterConfig={props.initialFilterConfig}
        persistentFilterConfig={props.persistentFilterConfig}
        pagination={props.pagination}
        showPagination
        sectionClassName="white-table"
      >
        {/* <Button onClick={handleImportMatchPayments} noLoading className="btn-thinner btn-2">
          <Isvg src={ImportIcon} className="btn-icon" />
          Import
        </Button> */}
        {/* <Button onClick={handleOpenCreateModal} noLoading className="btn-thinner btn-2">
          <Isvg src={PlusIcon} className="btn-icon" />
          New Match Payment
        </Button> */}
      </Table>
    </div>
  );
};

export default FixtureMatchesTable;
